import {Deserializable} from "./deserializable.model";

export class SubjectUrgentOutcomeTemplate {

//    log_type_data_sector_id: number;
//    log_type_data_sector_name: string;
//    log_type_data_sector_description: string;

//     is_active: number;
    
//     condition_array: any; // Actual Saved Model JSON of the data section action in angular
//     condition_array_example: any; // Actual Example of Live event
//     condition_array_fields: any; // A collection of all fields available // and valid for conditional validation in automations
//     database_table_name: string; // The Real Mysql Database table name used
//     database_table_fields_array: any; // array of all the database fields
//     database_model_angular: any; // model code for angular
//     created_tested: number;
//     notes: string;

//     log_type_data_sector_colour;
//     log_type_data_sector_icon;

//     condition_array_keys_example: any; // list of all the keys and dfinitions of implimentation of variables to place into ""
//     database_mysql: any; // Insert model of the mysql at current state incase we have to reproduce the database
//     condition_array_example_notes: any; // Notes about the example condition_array_example in proactice and implimentation.
//     log_type_data_sector_type_id: any; // the ID of the data sector type.



    public suot_id?: any;
    public suot_height?: any;
    public suot_width?: any;
    public suot_template_HTM?: any;
    public suot_template_WORD?: any;
    public suot_promotion_id?: any;
    public suot_is_default_template?: any;
    public suot_condition_array?: any;
    public notes?: any;
    public created_tested?: any;
    public suot_description?: any;
    public suot_name?: any;

    public rule_1?: any
    public rule_rule?: any
    public rule_result?: any
    public update_job_status?: any
    public update_next_date?: any
    public update_final_date?: any
    public email_template_primary_HTML_rendered?: any
    public email_subject_primary_rendered?: any
    public note_template_HTML_rendered?: any

    public suot_agent_id?: any


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectUrgentOutcomeTemplate {
    Object.assign(this, input);

    return this;
  }


}
